import React from "react";
import {
  FaBell,
  FaChartBar,
  FaDownload,
  FaEye,
  FaFilter,
  FaInfoCircle,
  FaQuestionCircle,
  FaSearch,
  FaTh,
  FaUpload,
} from "react-icons/fa";
import "../styles/TransactionsPage.css";
import { getUserData } from "../utils/authStorage";

const Transactions = ({ isSidebarOpen }) => {
  const userData = getUserData();
  const user = userData?.user || userData?.data || userData || {};
  const userType = String(user?.user_type || user?.type || "").toLowerCase();
  const isSuperAdmin = userType === "admin";
  const isOrgAdmin = userType === "org" || userType === "org-admin" || userType === "organizationadmin";

  const superStats = [
    { label: "Total Transactions", value: "1.2M", trend: "+12.5%", tone: "blue" },
    { label: "Volume", value: "Rs 425.8M", trend: "+8.2%", tone: "teal" },
    { label: "Success Rate", value: "99.2%", trend: "Stable", tone: "green" },
    { label: "Failed Txns", value: "0.8%", trend: "-0.1%", tone: "rose" },
    { label: "Dynamic QR", value: "72%", trend: "", tone: "amber" },
    { label: "Static QR", value: "28%", trend: "", tone: "slate" },
  ];

  const superRows = [
    { id: "#TX-88219", org: "Global Corp", merchant: "Velvet Coffee", qrType: "Dynamic", amount: "Rs 42.50", status: "Success", time: "Oct 24, 14:22", settlement: "Settled" },
    { id: "#TX-88220", org: "Nexus Systems", merchant: "City Mart", qrType: "Static", amount: "Rs 12.90", status: "Failed", time: "Oct 24, 14:23", settlement: "N/A" },
    { id: "#TX-88221", org: "Global Corp", merchant: "Skyline Bistro", qrType: "Dynamic", amount: "Rs 156.00", status: "Success", time: "Oct 24, 14:25", settlement: "Processing" },
    { id: "#TX-88222", org: "Retail One", merchant: "Hyper Mall", qrType: "Dynamic", amount: "Rs 245.10", status: "Success", time: "Oct 24, 14:28", settlement: "Settled" },
  ];

  const superLiveFeed = [
    { code: "CC", amount: "Rs 124.99", org: "Global Corp", when: "2s ago", tone: "teal" },
    { code: "VC", amount: "Rs 12.50", org: "Velvet Coffee", when: "8s ago", tone: "green" },
    { code: "NS", amount: "Rs 2,450.00", org: "Nexus", when: "13s ago", tone: "rose" },
    { code: "RM", amount: "Rs 68.00", org: "Retail Mart", when: "15s ago", tone: "amber" },
    { code: "CP", amount: "Rs 124.90", org: "City Point", when: "22s ago", tone: "slate" },
  ];

  const trendLine = [46, 62, 54, 58, 74, 76, 50, 40, 82, 84, 60];
  const peakBars = [28, 38, 22, 86, 78, 46, 34];

  if (isSuperAdmin) {
    return (
      <div className={`tsa-page ${isSidebarOpen ? "shifted" : ""}`}>
        <div className="tsa-topbar">
          <div className="tsa-search">
            <FaSearch />
            <input type="text" placeholder="Search reports..." />
          </div>
        </div>

        <div className="tsa-stats">
          {superStats.map((card) => (
            <article key={card.label} className={`tsa-stat tsa-stat--${card.tone}`}>
              <span>{card.label}</span>
              <strong>{card.value}</strong>
              <small>{card.trend}</small>
            </article>
          ))}
        </div>

        <div className="tsa-grid">
          <section className="tsa-main">
            <div className="tsa-filtersbar">
              <button type="button" className="tsa-filter tsa-filter--label"><FaFilter /> Filters</button>
              <button type="button" className="tsa-filter">All Organizations</button>
              <button type="button" className="tsa-filter">Last 24 Hours</button>
              <button type="button" className="tsa-pill active">Success</button>
              <button type="button" className="tsa-pill">Pending</button>
              <button type="button" className="tsa-pill">Failed</button>
              <div className="tsa-range">
                <label>Amount Range</label>
                <span>Rs 0 - Rs 10k</span>
              </div>
            </div>

            <article className="tsa-card tsa-table-card">
              <table className="tsa-table">
                <thead>
                  <tr>
                    <th>TX ID</th>
                    <th>Organization</th>
                    <th>Merchant</th>
                    <th>QR Type</th>
                    <th>Amount</th>
                    <th>Status</th>
                    <th>Time</th>
                    <th>Settlement</th>
                  </tr>
                </thead>
                <tbody>
                  {superRows.map((row) => (
                    <tr key={row.id}>
                      <td className="tsa-id">{row.id}</td>
                      <td>{row.org}</td>
                      <td>{row.merchant}</td>
                      <td><span className="tsa-chip">{row.qrType}</span></td>
                      <td>{row.amount}</td>
                      <td><span className={`tsa-status tsa-status--${row.status.toLowerCase()}`}>{row.status}</span></td>
                      <td>{row.time}</td>
                      <td><span className={`tsa-settle tsa-settle--${row.settlement.toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "")}`}>{row.settlement}</span></td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <div className="tsa-table-footer">
                <span>Showing 1-10 of 1.2M entries</span>
                <div className="tsa-pages">
                  <button type="button">&lt;</button>
                  <button type="button" className="active">1</button>
                  <button type="button">2</button>
                  <button type="button">3</button>
                  <button type="button">&gt;</button>
                </div>
              </div>
            </article>

            <div className="tsa-insights">
              <article className="tsa-card">
                <div className="tsa-card-head">
                  <h3>Trend</h3>
                  <FaChartBar />
                </div>
                <small>Hourly Volume</small>
                <div className="tsa-trendline">
                  {trendLine.map((point, index) => (
                    <span key={index} style={{ height: `${point}%` }} />
                  ))}
                </div>
              </article>

              <article className="tsa-card">
                <div className="tsa-card-head">
                  <h3>Peak Hours</h3>
                  <FaChartBar />
                </div>
                <small>Activity Heatmap</small>
                <div className="tsa-bars">
                  {peakBars.map((bar, index) => (
                    <span key={index} style={{ height: `${bar}%` }} />
                  ))}
                </div>
              </article>

              <article className="tsa-card">
                <div className="tsa-card-head">
                  <h3>Distribution</h3>
                  <FaInfoCircle />
                </div>
                <small>By Merchant Type</small>
                <div className="tsa-distribution">
                  <div className="tsa-ring"><strong>64%</strong><span>Retail</span></div>
                </div>
              </article>
            </div>
          </section>

          <aside className="tsa-side">
            <article className="tsa-card tsa-side-card">
              <div className="tsa-side-head">
                <h4>Live Feed</h4>
                <small>Real Time</small>
              </div>
              <div className="tsa-live-list">
                {superLiveFeed.map((item) => (
                  <div key={`${item.code}-${item.when}`} className="tsa-live-item">
                    <span className={`tsa-live-dot tsa-live-dot--${item.tone}`}>{item.code}</span>
                    <div>
                      <strong>{item.amount}</strong>
                      <p>{item.org} • {item.when}</p>
                    </div>
                  </div>
                ))}
              </div>
            </article>

            <article className="tsa-card tsa-side-card tsa-side-alert">
              <div className="tsa-side-head">
                <h4>System Alerts</h4>
              </div>
              <div className="tsa-alert-box">
                <strong>Anomalous Volume Detected</strong>
                <p>Merchant #4492 showing 300% spike in semi-static QR transactions.</p>
                <button type="button">Investigate</button>
              </div>
            </article>

            <article className="tsa-card tsa-side-card">
              <div className="tsa-side-head">
                <h4>Recent Failures</h4>
              </div>
              <div className="tsa-failure-list">
                <div>
                  <strong>#TX-88220</strong>
                  <p>Nexus Timeout</p>
                  <button type="button">Retry</button>
                </div>
                <div>
                  <strong>#TX-88214</strong>
                  <p>Blocked by issuer</p>
                  <button type="button">i</button>
                </div>
              </div>
            </article>
          </aside>
        </div>
      </div>
    );
  }

  const stats = [
    { label: "Total Transactions", value: "1.2M", trend: "+2.4%", tone: "teal" },
    { label: "Revenue", value: "Rs 425.8M", trend: "+8.2%", tone: "mint" },
    { label: "Success Rate", value: "99.2%", trend: "Target 99%", tone: "green" },
    { label: "Pending Settlements", value: "1,240", trend: "", tone: "amber" },
    { label: "Avg. Trans. Size", value: "Rs 354.80", trend: "", tone: "slate" },
    { label: "QR Conversion", value: "72%", trend: "High", tone: "violet" },
  ];

  const trendBars = [42, 56, 48, 62, 70, 58, 64, 74, 68, 72, 40, 34, 28, 46, 66];

  const txRows = [
    { id: "TXN-8492023", merchant: "Urban Retail Co.", agent: "#124", type: "Dynamic", amount: "Rs 1,240.00", date: "Oct 24, 14:20", status: "Success", settlement: "Settled" },
    { id: "TXN-8492024", merchant: "Skyline Logistics", agent: "#088", type: "Static", amount: "Rs 45.90", date: "Oct 24, 14:18", status: "Failed", settlement: "N/A" },
    { id: "TXN-8492025", merchant: "Green Bistro", agent: "#124", type: "Dynamic", amount: "Rs 312.00", date: "Oct 24, 13:55", status: "Processing", settlement: "Pending" },
  ];

  const alerts = [
    { title: "High Volume Detected", text: "Retail sector activity is 44% above baseline." },
    { title: "Network Latency (Asia)", text: "Average processing time increased to 1.2s." },
  ];

  const failedPayments = [
    { id: "ERR_402", text: "Rs 1,450.00 - Urban Retail", when: "2 mins ago" },
    { id: "ERR_091", text: "Rs 25.00 - Skyline Log.", when: "12 mins ago" },
    { id: "ERR_402", text: "Rs 8,100.00 - Luxe Jewelers", when: "45 mins ago" },
  ];

  const settlements = [
    { batch: "Batch #902", amount: "Rs 4.2M" },
    { batch: "Batch #901", amount: "Rs 1.8M" },
    { batch: "Batch #900", amount: "Rs 3.3M" },
  ];

  if (!isOrgAdmin) {
    return (
      <div className={`msd-container ${isSidebarOpen ? "shifted" : ""}`}>
        <div className="msd-card">
          <div className="msd-card__head">
            <div>
              <div className="msd-card__title">Transactions</div>
              <div className="msd-card__subtitle">Search and monitor transaction activity</div>
            </div>
          </div>
          <div className="msd-card__body">
            <p className="msd-muted">Coming soon</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={`tl-page ${isSidebarOpen ? "shifted" : ""}`}>
      <div className="tl-topbar">
        <div className="tl-search">
          <FaSearch />
          <input type="text" placeholder="Search reports..." />
        </div>
        <div className="tl-topbar-actions">
          <button type="button" className="tl-btn tl-btn--ghost"><FaDownload /> Download PDF</button>
          <button type="button" className="tl-btn tl-btn--primary"><FaUpload /> Export All CSV</button>
        </div>
      </div>

      <div className="tl-header">
        <h2>Transaction Ledger</h2>
        <p>Real-time overview of global flows and settlements</p>
      </div>

      <div className="tl-stats">
        {stats.map((s) => (
          <article className={`tl-stat tl-stat--${s.tone}`} key={s.label}>
            <span>{s.label}</span>
            <strong>{s.value}</strong>
            <small>{s.trend}</small>
          </article>
        ))}
      </div>

      <div className="tl-filters">
        <div className="tl-filter"><label>Filters</label>All Merchants</div>
        <div className="tl-filter">All Agents</div>
        <div className="tl-filter">Last 7 Days</div>
        <div className="tl-filter">Status: All</div>
        <div className="tl-filter">QR: Both</div>
        <div className="tl-filter tl-filter--search"><FaSearch /> Quick find...</div>
      </div>

      <div className="tl-grid">
        <section className="tl-main">
          <div className="tl-duo">
            <article className="tl-card">
              <div className="tl-card-head">
                <h3>Revenue Trend</h3>
                <small>Daily Total (EUR)</small>
              </div>
              <div className="tl-trendbars">
                {trendBars.map((b, i) => (
                  <span key={i} style={{ height: `${b}%` }} />
                ))}
              </div>
            </article>

            <article className="tl-card">
              <div className="tl-card-head">
                <h3>Merchant Distribution</h3>
                <small>By Category</small>
              </div>
              <div className="tl-donut-wrap">
                <div className="tl-donut"><span>104</span><small>active</small></div>
                <ul>
                  <li><i className="teal" />Retail (68%)</li>
                  <li><i className="mint" />Services (22%)</li>
                  <li><i className="slate" />Others (10%)</li>
                </ul>
              </div>
            </article>
          </div>

          <article className="tl-card tl-table-card">
            <div className="tl-card-head">
              <h3>Recent Transactions</h3>
              <button type="button">View All Activity</button>
            </div>

            <table className="tl-table">
              <thead>
                <tr>
                  <th>Transaction ID</th>
                  <th>Merchant</th>
                  <th>Agent</th>
                  <th>QR Type</th>
                  <th>Amount</th>
                  <th>Date</th>
                  <th>Status</th>
                  <th>Settlement</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {txRows.map((row) => (
                  <tr key={row.id}>
                    <td>{row.id}</td>
                    <td>{row.merchant}</td>
                    <td>{row.agent}</td>
                    <td><span className="tl-chip">{row.type}</span></td>
                    <td>{row.amount}</td>
                    <td>{row.date}</td>
                    <td><span className={`tl-status tl-status--${row.status.toLowerCase()}`}>{row.status}</span></td>
                    <td><span className="tl-settlement">{row.settlement}</span></td>
                    <td className="tl-actions"><FaEye /><FaUpload /><FaFilter /></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </article>
        </section>

        <aside className="tl-side">
          <article className="tl-card tl-side-card">
            <div className="tl-side-title"><FaBell /> System Alerts</div>
            <div className="tl-alerts">
              {alerts.map((a) => (
                <div key={a.title}>
                  <strong>{a.title}</strong>
                  <p>{a.text}</p>
                </div>
              ))}
            </div>
          </article>

          <article className="tl-card tl-side-card">
            <div className="tl-side-title">Failed Payments</div>
            <div className="tl-fails">
              {failedPayments.map((f) => (
                <div key={`${f.id}-${f.when}`}>
                  <strong>{f.id}</strong>
                  <p>{f.text}</p>
                  <small>{f.when}</small>
                </div>
              ))}
            </div>
          </article>

          <article className="tl-card tl-side-card">
            <div className="tl-side-title">Recent Settlements</div>
            <ul className="tl-settlements">
              {settlements.map((s) => (
                <li key={s.batch}><span>{s.batch}</span><strong>{s.amount}</strong></li>
              ))}
            </ul>
            <div className="tl-next-pay">
              <small>Next Payout</small>
              <strong>82%</strong>
            </div>
          </article>
        </aside>
      </div>
    </div>
  );
};

export default Transactions;
